import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitolonavalacab() {



const cardData = {
  keyword: "Mumbai to Lonavala Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Lonavala cab services for travelers looking to enjoy a scenic hill station getaway from the bustling city. Whether you are planning a weekend trip, family vacation, romantic escape, or group outing, our cab service ensures a safe and smooth journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in highway and hill driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Lonavala cab services.",

topPlaces: [
  {
    title: "Lonavala Lake",
    description:
      "Lonavala Lake is a serene destination ideal for nature lovers and photography enthusiasts, especially during the monsoon season when the surrounding greenery is lush and vibrant. Visitors can enjoy peaceful walks, picnics, and scenic views of the hills. A cab ride ensures comfortable travel from Mumbai, giving you flexibility in timing and allowing enough leisure to relax by the water without worrying about local transport or parking."
  },
  {
    title: "Bhushi Dam",
    description:
      "Bhushi Dam is a popular monsoon attraction in Lonavala where visitors can enjoy the cascading water and take part in recreational activities. The dam is surrounded by picturesque hills, making it a perfect spot for photography and picnics. Traveling by cab allows visitors to reach the dam conveniently, explore at their own pace, and combine the visit with other nearby attractions in a hassle-free manner."
  },
  {
    title: "Tiger’s Leap",
    description:
      "Tiger’s Leap is a famous cliff-top viewpoint in Lonavala that offers panoramic views of the Sahyadri mountains, valleys, and waterfalls. The site is ideal for sunrise or sunset photography and short treks. Using a cab service ensures comfortable transport to the viewpoint, flexible timing to enjoy the scenery, and easy inclusion in a day’s sightseeing itinerary along with other Lonavala attractions."
  },
  {
    title: "Rajmachi Fort",
    description:
      "Rajmachi Fort is a historic hill fort near Lonavala that attracts trekking enthusiasts and history buffs. The fort offers panoramic views, trekking trails, and insight into Maratha-era architecture. A cab ride provides convenient access to the base of the fort, allowing travelers to plan treks comfortably and combine the visit with nearby scenic spots without the stress of public transport."
  },
  {
    title: "Lion’s Point",
    description:
      "Lion’s Point is a popular viewpoint in Lonavala offering breathtaking views of the sunrise, sunset, and surrounding valleys. Visitors often enjoy short treks, photography, and local snacks sold at the site. Traveling by cab ensures a comfortable and timely arrival, enabling visitors to spend more time appreciating the natural beauty and less time worrying about transport."
  },
  {
    title: "Karla Caves",
    description:
      "Karla Caves are ancient rock-cut Buddhist caves near Lonavala, featuring intricate carvings, stupas, and a serene environment. The site is popular among history enthusiasts and spiritual travelers. A cab service allows visitors to reach the caves conveniently, explore at leisure, and include the site in a broader sightseeing itinerary without transportation concerns."
  },
  {
    title: "Della Adventure Park",
    description:
      "Della Adventure Park in Lonavala is a popular destination for thrill-seekers, offering activities like zip-lining, bungee jumping, ATV rides, and water sports. It is ideal for families, friends, and corporate outings. Traveling by cab ensures easy access to the park, flexibility in timing, and the comfort of returning safely after a day of adventure."
  },
  {
    title: "Lohagad Fort",
    description:
      "Lohagad Fort is a historical fort near Lonavala, famous for trekking, panoramic views, and Maratha-era architecture. Visitors can explore the fortifications, enjoy nature, and capture stunning photographs of the surrounding hills. A cab ride provides comfortable and convenient transport to the fort, making it easy to plan a day trip from Lonavala without worrying about local commuting."
  },
  {
    title: "Kune Falls",
    description:
      "Kune Falls is a majestic waterfall in Lonavala surrounded by lush greenery, perfect for photography, nature walks, and picnics. The falls are especially spectacular during the monsoon season. Traveling by cab allows visitors to reach this scenic spot conveniently, enjoy the natural beauty at leisure, and combine it with nearby sightseeing locations effortlessly."
  },
  {
    title: "Sunil’s Celebrity Wax Museum",
    description:
      "Sunil’s Celebrity Wax Museum in Lonavala features lifelike wax statues of famous Indian and international personalities. It is a fun and educational experience for families, kids, and tourists. A cab ride ensures comfortable access to the museum and makes it easy to include in a day’s itinerary along with natural and historical attractions around Lonavala."
  }
],




services: [
{
name: "Mumbai to Lonavala Cab",
description: "Mumbai to Lonavala cab service offers comfortable travel from Mumbai to the popular hill station of Lonavala. Our AC sedans, SUVs, and premium vehicles ensure a smooth journey via the Mumbai–Pune Expressway. Professional drivers are experienced with hill routes and ensure safe travel. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for weekend trips, family vacations, and sightseeing tours."
},
{
name: "Mumbai to Lonavala Taxi",
description: "Mumbai to Lonavala taxi service provides convenient road transportation for tourists and travelers visiting the scenic hill station. Comfortable AC vehicles ensure relaxed highway travel. Experienced drivers ensure safe driving through expressway and ghat sections. Flexible pickup options are available across Mumbai."
},
{
name: "Mumbai to Lonavala Cab Service",
description: "Mumbai to Lonavala cab service is designed for travelers seeking reliable and comfortable intercity travel. Well-maintained vehicles and trained drivers ensure smooth journeys along the expressway. Pickup is available from any location in Mumbai including airport terminals."
},
{
name: "Mumbai to Lonavala Taxi Service",
description: "Mumbai to Lonavala taxi service offers dependable travel for tourists, couples, and families planning a hill station trip. Comfortable vehicles ensure relaxed travel while professional drivers ensure safe highway driving."
},
{
name: "Cab from Mumbai to Lonavala",
description: "Cab from Mumbai to Lonavala provides a convenient private travel option for passengers planning short hill station trips. Comfortable vehicles ensure smooth highway travel. Experienced drivers ensure safe and timely arrival."
},
{
name: "Taxi from Mumbai to Lonavala",
description: "Taxi from Mumbai to Lonavala offers reliable transportation with comfortable AC vehicles and experienced drivers. The service is ideal for tourists visiting Lonavala for sightseeing and weekend holidays."
},
{
name: "Mumbai to Lonavala Cab Booking",
description: "Mumbai to Lonavala cab booking allows travelers to reserve vehicles easily for comfortable hill station travel. Instant booking confirmation and flexible pickup options simplify travel planning."
},
{
name: "Mumbai to Lonavala Taxi Booking Online",
description: "Online taxi booking from Mumbai to Lonavala allows passengers to reserve vehicles instantly from anywhere. Quick confirmation and easy scheduling make travel planning simple."
},
{
name: "Mumbai to Lonavala Cab Price",
description: "Mumbai to Lonavala cab price offers affordable and transparent fare options for travelers. Customers can choose sedan, SUV, or luxury vehicles depending on comfort and budget."
},
{
name: "Mumbai to Lonavala Taxi Fare",
description: "Mumbai to Lonavala taxi fare is calculated with transparent per-km pricing and simple billing. Travelers receive affordable travel options with clear fare structure."
},
{
name: "Mumbai to Lonavala One Way Cab",
description: "One way cab from Mumbai to Lonavala is ideal for travelers who only require drop service without return charges. This option helps reduce travel costs while ensuring comfortable transportation."
},
{
name: "Mumbai to Lonavala Round Trip Taxi",
description: "Round trip taxi from Mumbai to Lonavala offers convenient return travel for passengers planning sightseeing or weekend trips. Flexible return scheduling allows travelers to explore the hill station comfortably."
},
{
name: "Mumbai to Lonavala Innova Cab",
description: "Innova cab from Mumbai to Lonavala is ideal for families and group travelers needing spacious seating and luggage capacity. The premium MPV ensures comfortable hill station travel."
}
],

tableData: [
["Mumbai to Lonavala Cab","Mumbai to Lonavala Taxi"],
["Mumbai to Lonavala Cab Service","Mumbai to Lonavala Taxi Service"],
["Cab from Mumbai to Lonavala","Taxi from Mumbai to Lonavala"],
["Mumbai to Lonavala Cab Booking","Mumbai to Lonavala Taxi Booking Online"],
["Mumbai to Lonavala Cab Price","Mumbai to Lonavala Taxi Fare"],
["Mumbai to Lonavala One Way Cab","Mumbai to Lonavala Round Trip Taxi"],
["Mumbai to Lonavala Innova Cab","Best Cab Mumbai to Lonavala"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Lonavala route via the Mumbai–Pune Expressway and old highway. They understand the hill roads, traffic patterns, and scenic routes, ensuring a safe and smooth journey to this popular hill station."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and transparent pricing for Mumbai to Lonavala cab services. We share the complete fare details, toll charges, and trip packages before booking so you never face hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you are planning an early morning hill station trip or a late-night return journey, Omshree Cabs provides 24/7 cab booking support for Mumbai to Lonavala travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our vehicles are well-maintained, fully air-conditioned, and thoroughly cleaned before every trip. Our comfortable cars make your Lonavala hill station journey relaxing and enjoyable."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible travel options including one-way trips, round trips, and same-day return packages from Mumbai to Lonavala. Travelers can customize the travel schedule according to their convenience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles for family or group travel. Choose the vehicle that best suits your comfort and group size."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from your home, hotel, office, or airport anywhere in Mumbai. Our drivers arrive on time so your journey to Lonavala begins smoothly without travel hassle."
  },
  {
    WhyChooseheading: "Reliable & Punctual Service",
    WhyChoosedescription: "Omshree Cabs is known for punctual pickups and dependable service. Our drivers prioritize safety and customer comfort, ensuring a pleasant journey to Lonavala."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Lonavala by cab?", answer: "The distance from Mumbai to Lonavala is approximately 85 km and usually takes around 1.5–2 hours via the Mumbai–Pune Expressway." },
  { question: "Do you provide one-way Mumbai to Lonavala cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Lonavala." },
  { question: "Which vehicles are available for Mumbai to Lonavala travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Lonavala cab bookings." },
  { question: "Can we visit sightseeing places in Lonavala?", answer: "Yes, travelers can visit popular attractions like Tiger Point, Bhushi Dam, Lion’s Point, and Karla Caves during the trip." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return packages?", answer: "Yes, same-day return packages from Mumbai to Lonavala are available." },
  { question: "Can we stop for photos or sightseeing on the way?", answer: "Yes, passengers can request stops at scenic points during the journey." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and monsoon seasons when Lonavala is very popular." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Shah",
    feedback:
      "We booked Omshree Cabs for a Mumbai to Lonavala trip with friends. The driver was punctual and the car was very clean. Smooth ride and excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Mehta",
    feedback:
      "Our family trip to Lonavala from Mumbai was very comfortable with Omshree Cabs. On-time pickup, polite driver, and transparent pricing made the journey perfect.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lonavala Cab",
  "description": "Book Mumbai to Lonavala Cab with Omshree Cab for comfortable hill station travel. Reliable taxi service from Mumbai to Lonavala with options like Innova and other cabs for one-way or round trips. Affordable fares, easy online cab booking, and safe travel for your Lonavala trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3100"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Mumbai to Lonavala Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Lonavala Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Lonavala with Innova and other cabs for one-way or round trips. Affordable fares and easy online cab booking for your Lonavala trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitolonavalacab;